import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreLocationGroup, ILocationGroupsStore, ILocationGroupActions } from '../types';

const onRestoreLocationGroup: IThunkRestoreLocationGroup = thunk(
  async ({ setLocationGroups }: Actions<ILocationGroupActions>, payload, { getState }) => {
    const localState = getState() as ILocationGroupsStore;

    const { clinicId, id } = payload;

    await api.locationGroups.restoreLocationGroup(clinicId, id);

    const updatedList = localState.list.map(item =>
      item.id !== id ? item : { ...item, isArchived: false },
    );

    setLocationGroups({ items: updatedList });
  },
);

export default onRestoreLocationGroup;
